import { visit } from 'unist-util-visit';
import type { Root, Text, Link } from 'mdast';
import type { Plugin } from 'unified';

export const renderWithVariables = (
  markdown: string,
  vars: Record<string, string>
) =>
  markdown.replace(/{{\s*(\w+)\s*}}/g, (_, key) => vars[key] ?? `{{${key}}}`);

export const remarkVariablePlugin =
  (variables: Record<string, string>): Plugin<[], Root> =>
  () =>
  (tree: Root) => {
    // Replace in normal text
    visit(tree, 'text', (node: Text) => {
      node.value = renderWithVariables(node.value, variables);
    });

    // Replace in link URLs BEFORE encoding
    visit(tree, 'link', (node: Link) => {
      node.url = renderWithVariables(node.url, variables);
    });
  };
